__turbopack_context__.v({
  "link": "LinkSection-module-scss-module__K7vr9W__link",
});
